<template>
  <ElTabs :key="activeName.key" v-model="activeName.nav" type="card">
    <ElTabPane label="添加产品">
      <ProductNew :params="activeName.params" />
    </ElTabPane>
    <ElTabPane label="添加理疗项目">
      <PhysiotherapyNew :params="activeName.params" />
    </ElTabPane>
    <ElTabPane label="添加特色项目">
      <SpecialItemsNew :params="activeName.params" />
    </ElTabPane>
  </ElTabs>
</template>

<script>
import {menusNavigation} from '@/store';
import SpecialItemsNew from '@/components/project/SpecialItemsNew.vue';
import ProductNew from '@/components/project/ProductNew.vue';
import PhysiotherapyNew from '@/components/project/PhysiotherapyNew.vue';

export default {
  name: 'ProjectNew',
  components: {
    SpecialItemsNew,
    ProductNew,
    PhysiotherapyNew
  },
  props: {
    activeName: {
      type: Object,
      default: () => ({
        nav: '0'
      })
    }
  },
  data() {
    return {
      menusNavigation
    };
  }
};
</script>

<style lang="scss">
.ProjectNew {
  @import '@/assets/css/tab.scss';
  .product-new {
    padding: 30px 0 0 60px;
    .el-row {
      margin-bottom: 20px;
    }
  }
}
</style>
